import React from "react";
import styled from 'styled-components';

import { CDKGlobalHeader, GlobalHeaderIcons, GlobalHeaderIcon } from "@cdk-uip/react-global-header";

const OnePayHeader = styled(CDKGlobalHeader)`
  z-index: 99999;
`;

const Header = props => {

    const onePayHelpHandler = () => {
        window.open('http://dsonlinehelp.com/pid/oh/en_US/pid/help/applications/ab_onepay_cl/N/Content/My_Topics/Anchor_Pages/CL_LandingPage_OnePay.htm?utm_source=OnePay+Help&utm_medium=Application&utm_campaign=New+Help+Button&utm_id=Application+Help','_blank')
    }

    return (
        <OnePayHeader appName="OnePay" >
            <GlobalHeaderIcons>
                <GlobalHeaderIcon onClick={onePayHelpHandler}>help</GlobalHeaderIcon>
            </GlobalHeaderIcons>
        </OnePayHeader>
    );

}

export default Header;